import React, { useState, useEffect } from "react";
import { IProducts, IProductsList } from "../../../products/dto/IProducts";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageTemplate } from "../../../../shared/layout/PageTemplate";
import { ProductsService } from "../../../products/service";
import { ErrorToast } from "../../../../shared/toasters/toasters";
import { AttributesView } from "../../../products/attributes/components/AttributesView";

export const ViewAttributesCrawled = () => {
  const [currentProduct, setCurrentProduct] = useState<IProducts>();
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    id &&
      ProductsService.getViewProductsById(+id)
        .then((response) => {
          setCurrentProduct(response);
        })
        .catch((error) => ErrorToast(error));
  }, [id]);
  return (
    // <PageTemplate title={`${t("products.attributes_view")}`}>
    <>
      <div className="col-md-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="d-flex align-itmes-end">
            <ul className="nav nav-pills nav-fill">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={`/app/pending-products/crawled/view/base-data/${id}`}
                >
                  {t("products.base_data_view")}
                </Link>
              </li>
              <li>
                <span className="nav-link active">
                  {t("products.attributes_view")}
                </span>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to={`/app/pending-products/crawled/view/content/${id}`}
                >
                  {t("products.content_view")}
                </Link>
              </li>
            </ul>
          </div>
          <>
            <ul className="nav nav-pills">
              <li className="nav-item">
                <a
                  rel="noreferrer"
                  target="_blank"
                  className="nav-link active"
                  href={`${currentProduct?.crawlerUrl}`}
                >
                  {t("crawlers.url")}
                </a>
              </li>
            </ul>
          </>
        </div>
      </div>
      <AttributesView currentProduct={currentProduct as IProductsList} />
    </>
    // </PageTemplate>
  );
};
